import CompTranslationsManager from '@/manager/3.6/CompTranslationsManager';
import IComp from '@/models/Comp';

export default {
    /**
     * Run field rules on the given comp.
     * The dependency order between managers and stores is currently backward on this.
     * Store helpers are placeholders for backward dependency order situations and will go away
     * when we correct it, refactoring the business logic out of the store.
     * @param comp
     * @param excludeNoValueAndNoSourceInitial
     */
    async run(comp: IComp, excludeNoValueAndNoSourceInitial: boolean): Promise<void> {
        return await CompTranslationsManager.run(comp, excludeNoValueAndNoSourceInitial);
    },

    /**
     * Run field rules on a field identified by the given comp and fieldId.
     * The dependency order between managers and stores is currently backward on this.
     * Store helpers are placeholders for backward dependency order situations and will go away
     * when we correct it, refactoring the business logic out of the store.
     * @param comp
     * @param fieldId
     */
    async runOnField(comp: IComp, fieldId: number): Promise<void> {
        return await CompTranslationsManager.runOnField(comp, fieldId);
    },
};
